// Hardcoded data and configuration for Condo Unit Payment Summary.
// Backend developer will eventually replace these with API calls.

export const TABS = [
  { value: "rental", label: "Rental" },
  { value: "misc-expenses", label: "Misc Expense" },
  { value: "utilities", label: "Utilities" },
  { value: "security-deposit", label: "Security Deposit" },
  { value: "allowance", label: "Allowance" }
];

export const RENTAL_FILTERS = {
  condo: [
    { value: "all", label: "All" },
    { value: "oriental", label: "Oriental KH" },
    { value: "141", label: "141 Apartment" }
  ],
  condoUnit: [{ value: "all", label: "All" }],
  lessee: [{ value: "all", label: "All" }],
  lessor: [{ value: "all", label: "All" }],
  currency: [
    { value: "php", label: "PHP" },
    { value: "usd", label: "USD" }
  ],
  year: [
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" }
  ]
};

export const SECURITY_DEPOSIT_FILTERS = {
  condo: RENTAL_FILTERS.condo,
  condoUnit: RENTAL_FILTERS.condoUnit,
  securityDepositReturned: [
    { value: "all", label: "All" },
    { value: "yes", label: "Returned" },
    { value: "no", label: "Not returned" }
  ]
};

export const RENTAL_COLUMN_OPTIONS = [
  { id: "column-unit", label: "Unit", defaultChecked: true },
  { id: "column-condo", label: "Condo", defaultChecked: true },
  { id: "column-lessee", label: "Lessee", defaultChecked: true },
  { id: "column-lessor", label: "Lessor", defaultChecked: true },
  { id: "column-condo-code", label: "Condo Company Code", defaultChecked: false },
  { id: "column-monthly-rent", label: "Monthly Rent", defaultChecked: true },
  { id: "column-security-deposit", label: "Security Deposit", defaultChecked: true },
  { id: "column-advance-payment", label: "Advance Payment", defaultChecked: true },
  { id: "column-total-deposit", label: "Total Deposit", defaultChecked: true },
  { id: "column-payment-term", label: "Payment Term", defaultChecked: true },
  { id: "column-contract-start", label: "Contract Start Date", defaultChecked: true },
  { id: "column-contract-end", label: "Contract End Date", defaultChecked: true },
  { id: "column-condo-company", label: "Condo Company", defaultChecked: true }
];

export const MISC_COLUMN_OPTIONS = [
  { id: "misc-column-unit", label: "Unit", defaultChecked: true },
  { id: "misc-column-condo", label: "Condo", defaultChecked: true },
  { id: "misc-column-lessee", label: "Lessee", defaultChecked: true },
  { id: "misc-column-lessor", label: "Lessor", defaultChecked: true },
  { id: "misc-column-contact", label: "Contact", defaultChecked: false },
  { id: "misc-column-condo-company", label: "Condo Company", defaultChecked: false },
  { id: "misc-column-condo-code", label: "Condo Company Code", defaultChecked: false }
];

export const RENTAL_SUMMARY_ROWS = [
  {
    id: 1,
    unit: "10-B Island Plaza",
    condo: "Island Plaza Salcedo",
    lessee: "Island Plaza Salcedo",
    lessor: "SG001",
    paymentTerm: "12 months",
    monthlyRent: "PHP 125,000.00",
    january: "PHP 125,000.00",
    february: "PHP 125,000.00",
    march: "PHP 125,000.00",
    april: "PHP 125,000.00",
    may: "PHP 125,000.00",
    june: "PHP 125,000.00",
    july: "PHP 125,000.00",
    august: "PHP 125,000.00",
    september: "PHP 125,000.00",
    october: "PHP 125,000.00",
    november: "PHP 125,000.00",
    december: "PHP 125,000.00",
    annualPaid: "PHP 250,000.00",
    annualUnpaid: "PHP 1,125,000.00",
    annualTotal: "PHP 1,375,000.00"
  },
  {
    id: 2,
    unit: "1003 Oriental KH",
    condo: "Oriental KH",
    lessee: "JK",
    lessor: "0",
    paymentTerm: "6 months",
    monthlyRent: "PHP 33,361.00",
    january: "PHP 33,361.00",
    february: "PHP 33,361.00",
    march: "PHP 33,361.00",
    april: "PHP 33,361.00",
    may: "PHP 33,361.00",
    june: "PHP 33,361.00",
    july: "-",
    august: "-",
    september: "-",
    october: "-",
    november: "-",
    december: "-",
    annualPaid: "PHP 0.00",
    annualUnpaid: "PHP 366,970.95",
    annualTotal: "PHP 366,970.95"
  }
];

export const MISC_SUMMARY_ROWS = [
  {
    id: 1,
    unit: "10-B Island Plaza",
    condo: "Island Plaza Salcedo",
    lessee: "SG001",
    lessor: "CAD REALTY DEVT CORP",
    january: "PHP 0.00",
    february: "PHP 0.00",
    march: "PHP 0.00",
    april: "PHP 0.00",
    may: "PHP 0.00",
    june: "PHP 0.00",
    july: "PHP 0.00",
    august: "PHP 0.00",
    september: "PHP 0.00",
    october: "PHP 0.00",
    november: "PHP 0.00",
    december: "PHP 0.00",
    annualTotal: "PHP 8,928.56"
  },
  {
    id: 2,
    unit: "1024 Jazz Residences",
    condo: "Jazz Residences",
    lessee: "Cleo Conti",
    lessor: "n/a",
    january: "PHP 0.00",
    february: "PHP 0.00",
    march: "PHP 0.00",
    april: "PHP 0.00",
    may: "PHP 0.00",
    june: "PHP 0.00",
    july: "PHP 0.00",
    august: "PHP 0.00",
    september: "PHP 0.00",
    october: "PHP 0.00",
    november: "PHP 0.00",
    december: "PHP 0.00",
    annualTotal: "PHP 252,600.00"
  }
];

export const UTILITIES_SUMMARY_ROWS = [
  {
    id: 1,
    unit: "10-B Island Plaza",
    condo: "Island Plaza Salcedo",
    lessee: "SG001",
    lessor: "CAD REALTY DEVT CORP",
    january: "PHP 0.00",
    february: "PHP 0.00",
    march: "PHP 0.00",
    april: "PHP 0.00",
    may: "PHP 0.00",
    june: "PHP 0.00",
    july: "PHP 0.00",
    august: "PHP 0.00",
    september: "PHP 0.00",
    october: "PHP 0.00",
    november: "PHP 0.00",
    december: "PHP 0.00",
    annualTotal: "PHP 104,848.22"
  }
];

export const ALLOWANCE_SUMMARY_ROWS = [
  {
    id: 1,
    unit: "10-B Island Plaza",
    condo: "Island Plaza Salcedo",
    lessee: "SG001",
    lessor: "CAD REALTY DEVT CORP",
    january: "PHP 0.00",
    february: "PHP 0.00",
    march: "PHP 0.00",
    april: "PHP 0.00",
    may: "PHP 0.00",
    june: "PHP 0.00",
    july: "PHP 0.00",
    august: "PHP 0.00",
    september: "PHP 0.00",
    october: "PHP 0.00",
    november: "PHP 0.00",
    december: "PHP 0.00",
    annualTotal: "PHP 0.00"
  }
];

export const SECURITY_DEPOSIT_SUMMARY_ROWS = [
  {
    id: 1,
    condo: "Ivan Christopher Legaspi",
    condoUnit: "68 Philip Street Muntinlupa Village, Paranaque Cit",
    lessee: "Ousian Solution Inc.",
    lessor: "Ivan Christopher Legaspi",
    contact: "+63 917 123 4567",
    contractStartDate: "11/06/2025",
    contractEndDate: "10/06/2026",
    terminationDate: "10/06/2026",
    securityDeposit: "PHP 45,000.00",
    returnedAmount: "PHP 10,000.00",
    expense: "PHP 5,000.00",
    skipped: false
  },
  {
    id: 2,
    condo: "Dasmarinas Village",
    condoUnit: "236B Mabolo St.",
    lessee: "Steven Teo",
    lessor: "Tierra International Construction",
    contact: "+63 917 987 6543",
    contractStartDate: "15/06/2025",
    contractEndDate: "31/05/2027",
    terminationDate: "31/05/2027",
    securityDeposit: "PHP 840,000.00",
    returnedAmount: "PHP 200,000.00",
    expense: "PHP 12,500.00",
    skipped: false
  }
];
